import {
  GET_REFER_FRIEND_FEATURE,
  GET_REFER_FRIEND_FEATURE_SUCCESS,
  GET_REFER_FRIEND_FEATURE_FAILED,
  UPDATE_REFER_FRIEND_FEATURE,
  UPDATE_REFER_FRIEND_FEATURE_SUCCESS,
  UPDATE_REFER_FRIEND_FEATURE_FAILED,
  RESET_REFER_FRIEND_FEATURE_FORM,
  GET_REFER_FRIEND_REPORTS,
  GET_REFER_FRIEND_REPORTS_SUCCESS,
  GET_REFER_FRIEND_REPORTS_FAILED,
  RESET_REFER_FRIEND_REPORTS,
} from "./actionTypes"

export const getReferFriendFeature = params => ({
  type: GET_REFER_FRIEND_FEATURE,
  payload: params,
})

export const getReferFriendFeatureSuccess = response => ({
  type: GET_REFER_FRIEND_FEATURE_SUCCESS,
  payload: response,
})

export const getReferFriendFeatureFailed = error => ({
  type: GET_REFER_FRIEND_FEATURE_FAILED,
  payload: error,
})

export const updateReferFriendFeature = params => ({
  type: UPDATE_REFER_FRIEND_FEATURE,
  payload: params,
})

export const updateReferFriendFeatureSuccess = response => ({
  type: UPDATE_REFER_FRIEND_FEATURE_SUCCESS,
  payload: response,
})

export const updateReferFriendFeatureFaield = error => ({
  type: UPDATE_REFER_FRIEND_FEATURE_FAILED,
  payload: error,
})

export const resetReferFriendFeatureForm = () => ({
  type: RESET_REFER_FRIEND_FEATURE_FORM,
  payload: {},
})

export const getReferFriendReports = params => ({
  type: GET_REFER_FRIEND_REPORTS,
  payload: params,
})

export const getReferFriendReportsSuccess = response => ({
  type: GET_REFER_FRIEND_REPORTS_SUCCESS,
  payload: response,
})

export const getReferFriendReportsFailed = error => ({
  type: GET_REFER_FRIEND_REPORTS_FAILED,
  payload: error,
})

export const resetReferFriendReports = () => ({
  type: RESET_REFER_FRIEND_REPORTS,
  payload: {},
})
